<template>
  <b-modal :visible="show"
           class="first-page-modal"
           lazy
           centered
           hide-footer
           :title="title"
           @hidden="clearPageModal"
           size="lg">
    <div v-if="type === PAGE" v-html="pageContent"></div>
    <div v-else-if="type === PRIVACY_POLICY">
      <privacy-policy-content terms-in-modal></privacy-policy-content>
    </div>
  </b-modal>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import PrivacyPolicyContent from "../content/PrivacyPolicyContent";
import {PAGE, PRIVACY_POLICY} from "@/utils/PageModalTypes";

export default {
  name: "PageModal",
  components: {PrivacyPolicyContent},
  component: {},
  data() {
    return {
      PAGE: PAGE,
      PRIVACY_POLICY: PRIVACY_POLICY,
      pageContent: null,
    }
  },
  updated() {
    if (this.show) {
      this.getPage();
    }
  },
  methods: {
    ...mapActions([
      'clearPageModal'
    ]),
    getPage() {
      if (this.content) {
        return this.$http.get('/page/' + this.content)
            .then((r) => {
              this.pageContent = r.data.page.content
            })
            .catch(() => {
              this.clearPageModal()
            })
      }
    },
  },
  computed: {
    ...mapState({
      show: state => state.pageModal.pageModal.show,
      title: state => state.pageModal.pageModal.title,
      type: state => state.pageModal.pageModal.type,
      content: state => state.pageModal.pageModal.content
    }),
  }
}
</script>

<style>
.modal-lg{
  max-width: 1000px !important;
}
.first-page-modal .modal-body {
  overflow-y: auto;
  overflow-x: hidden;
  height: 60vh;
}
</style>
